import { initialValuesLocality as initialValues } from '../../../../../../../helpers/variablesInitialValues';
import * as types from '../types/localityType';

const initialState = {
	perPage: 10,
	page: 1,
	pages: 1,
	search: '',
	arrayList: [],
	arrayListToDropdown: [],
	refreshTable: false,
	isOpenModal: false,
	isOpenModalPermission: false,
	isLoadingShow: false,
	isLoadingForm: false,
	formType: '',
	formData: initialValues
};

const localityReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case types.PER_PAGE_LOCALITY:
			return {
				...state,
				perPage: payload
			};
		
		case types.PAGE_LOCALITY:
			return {
				...state,
				page: payload
			};
		
		case types.PAGES_LOCALITY:
			return {
				...state,
				pages: payload
			};
		
		case types.SEARCH_LOCALITY:
			return {
				...state,
				search: payload
			};
		
		case types.ARRAY_LIST_LOCALITY:
			return {
				...state,
				arrayList: payload
			};
		
		case types.ARRAY_LIST_TO_DROPDOWN_LOCALITY:
			return {
				...state,
				arrayListToDropdown: payload
			};
		
		case types.REFRESH_TABLE_LOCALITY:
			return {
				...state,
				refreshTable: payload
			};
		
		case types.IS_OPEN_MODAL_LOCALITY:
			return {
				...state,
				isOpenModal: payload
			};
		
		case types.IS_LOADING_SHOW_LOCALITY:
			return {
				...state,
				isLoadingShow: payload
			};
		
		case types.IS_LOADING_FORM_LOCALITY:
			return {
				...state,
				isLoadingForm: payload
			};
		
		case types.FORM_TYPE_LOCALITY:
			return {
				...state,
				formType: payload
			};
		
		case types.FORM_DATA_LOCALITY:
			return {
				...state,
				formData: payload
			};
		
		default:
			return state
	}
};

export default localityReducer;
